<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { byDocumentType } from '@/utils/document-setting';

export default {
inject: ['setLoading'],
data() {
  return {
    title: "Sales",
    text: "Sales",
    app_currency: '',
    data: [],
    type: 'invoice',
    setting: [],
    pagination: {
      current_page: 1,
      per_page: 25,
      last_page: 1,
      total: 0,
      links: []
    },
    status: '',
    search_keyword: '',
    selected_rows: [],
    status_data: [],
  };
},

 computed: {
  serialNo(){
   return (this.pagination.current_page - 1) * this.pagination.per_page;
  },
  text1(){
   return `Invoices (${this.pagination.total})`; 
  },
  allSelected() {
   return this.data?.length && this.selected_rows.length === this.data.length;
  }
 },
 async mounted() {  
  this.loadAll();
 }, 

 methods: {

  async selectStatus(status){
   this.status = status;
   await this.invoices();
  },

  handleToggleAll(event) {
   this.selected_rows = this.$toggleAll(event, this.data);
  },

  async loadAll(){
   this.statusData();
   this.byType(this.type);
   this.invoices();
   this.app_currency = await this.$appCurrency();
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    this.setting = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async statusData(){
   try{
    const response = await axios.get(`/invoices/status-wise/data`);
    this.status_data = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },

  async viewPDF(id){
   try{
    const response = await axios.get(`/invoices/${id}/pdf`,{
     responseType: 'blob' 
    });

    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
  
    window.open(fileURL, '_blank');
   }catch(error){
    this.$swalToast("Failed to open PDF", 'error');
    console.error(error);
   }
  },

  async invoices(page = 1){
   this.setLoading(true);
   try{
    const params = {
     page,
     status: this.status || '',
     search_keyword: this.search_keyword.trim() || ''
    };
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/invoices?${query_string}`);
    this.data = response.data.data.data;
    this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
    };
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  partyURL(row){
   if(row.party_type === "App\\Models\\Lead"){
    return `/crm/leads-details/${row.party_id}`;
   }
   if(row.party_type === "App\\Models\\Customer"){
    return `/crm/customers-details/${row.party_id}`;
   }
   return "#";
  },

  changePage(url) {
   if (!url) return;
   const page = new URL(url).searchParams.get("page");
   this.invoices(page);
  },

  bulkAction(){
   if(this.selected_rows.length){
    this.$refs.invoiceModal.bulkAction(this.selected_rows); 
    const modalEl = document.getElementById("bulk_action_invoice");
    let modal = Modal.getInstance(modalEl);
    if(!modal){ modal = new Modal(modalEl);}
    modal.show();
   }else{
    this.$swalToast("Please select at least one option.", 'warning');
   }
  }, 

  clearFilter(){
   this.status = '';
   this.search_keyword = '';
   this.invoices();
  },

},
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      
      <div class="me-2 mb-2"> 
      <button type="button" class="btn btn-outline-secondary" @click="bulkAction();"><i class="ti ti-playstation-square me-1"></i> Bulk Actions</button> 
      </div>
      
      <div class="mb-2">
        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#invoice_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.invoiceModal.add();">
          <i class="ti ti-circle-plus me-2"></i>Add Invoice
        </a>
      </div>
      
    </div>
  </div>
  <!-- /Breadcrumb -->

    <div class="row">

   <div class="col-md-3 cursor-pointer" v-for="(row, index) in status_data" :key="index" @click="selectStatus(row.status);">
    <div class="card flex-fill">
    <div class="card-body">
    <div class="d-flex align-items-center overflow-hidden mb-2">
    <div>
      <p class="fs-12 fw-normal mb-1 text-truncate">{{row.status}}</p>
      <h5>{{app_currency.code}} {{row.amount}}</h5>
    </div>
    </div>
    <div class="attendance-report-bar mb-2">
    <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 5px;">
      <div :class="`progress-bar ${row.bg_color}`" :style="`width: ${row.percentage}%;`"></div>
    </div>
    </div>
    <div>
    <p class="fs-12 fw-normal d-flex align-items-center text-truncate"><span class="text-muted fs-12 d-flex align-items-center me-1">Total: {{row.count}}</span></p>
    </div>
    </div>
    </div>
   </div> 

  </div>

  <div class="card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
  <h5>Invoices List</h5>
  <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="search_keyword !== '' || status !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  
    
    <div class="me-3">
     <select class="form-select" v-model="status" @change="invoices">
      <option value="">Status</option>
      <option value="Draft">Draft</option>
      <option value="Sent">Sent</option>
      <option value="Paid">Paid</option>
      <option value="Partial">Partial</option>
     </select>
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="invoices()"><i class="ti ti-search"></i></button>
    </div>

    </div>
 </div>
 <div class="card-body card-table-wrapper">
  <div class="custom-datatable-filter table-responsive"> 
    <table class="card-table" v-if="data?.length">
      <thead>
        <tr>
          <th>
           <div class="form-check form-checkbox-success mb-2">
           <input type="checkbox" class="form-check-input" :checked="allSelected" @change="handleToggleAll">
          </div> 
          </th>
          <th>#</th>
          <th>Invoice No</th>
          <th>Status</th>
          <th>Client</th>
          <th>Quotation</th>
          <th>Amount Without Tax</th>
          <th>Tax Amount</th>
          <th>Amount With Tax</th>
          <th>Issue Date</th>
          <th>Balance</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in data" :key="row.id">
          <td>
          <div class="form-check form-checkbox-success mb-2">
           <input type="checkbox" class="form-check-input" :value="row.id" v-model="selected_rows">
          </div>  
          </td>  
          <td>{{ serialNo + index + 1 }}.</td> 
          <td>
           <h6>
            <a :href="`/sales/invoices/view/${row.public_token}`" target="_blank" class="text-primary">{{ row.invoice_number }}</a>
           </h6>
          </td>
          <td><span class="badge rounded-pill bg-outline-secondary">{{ row.status }}</span></td>
          <td>
           <h6>
            <a :href="partyURL(row)" target="_blank">{{ row.party?.salutation }} {{ row.party?.name }}</a>
           </h6>
          </td>
          <td>
           <h6 v-if="row.quotation">
            <a :href="`/sales/quotations/view/${row.quotation?.public_token}`" target="_blank">{{ row.quotation?.subject }}</a>
           </h6>
           <span v-else>N/A</span>
          </td>
          <td>{{row.party?.currency?.code}} {{ row.subtotal }}</td>
          <td>{{row.party?.currency?.code}} {{ row.tax_amount }}</td>
          <td>{{row.party?.currency?.code}} {{ row.total }}</td>
          <td>{{ $formatDate(row.issue_date) }}</td>
          <td>{{row.party?.currency?.code}} {{ row.balance.toFixed(2) }}</td>
          <td>

            <div class="dropdown">
            <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="ti ti-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li v-if="row.balance !== 0">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#invoice_modal" @click="$refs.invoiceModal.editInvoice(row.public_token)"><i class="ti ti-edit me-1"></i>Edit</a>
            </li>
            <li v-if="row.status !== 'Paid'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#invoice_assign_modal" @click="$refs.invoiceModal.assignHistory(row.id, row.invoice_number)"><i class="ti ti-user-star me-1"></i>Assign User</a>
            </li>
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="viewPDF(row.id)"><i class="ti ti-file-type-pdf me-1"></i>View PDF</a>
            </li>
            <li v-if="setting?.send_on_email && row.status !== 'Paid'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#invoice_mail_modal" @click="$refs.invoiceModal.mailInvoice(row)"><i class="ti ti-mail me-1"></i>Send on Email</a>
            </li>
            <li v-if="row.status !== 'Paid'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#payment_receive_modal" @click="$refs.paymentModal.receive(row.id, row.invoice_number, row.party_id, row.balance, `Invoice`, 'Receive Payment')"><i class="ti ti-receipt-rupee me-1"></i>Receive Payment</a>
            </li>
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#invoice_delete_modal" @click="$refs.invoiceModal.editInvoice(row.public_token)"><i class="ti ti-trash me-1"></i>Delete</a>
            </li>
            </ul>
            </div> 

          </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="p-3 text-center text-muted"> No records found. </div>
  </div>

  <!-- Pagination -->
  <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
    <ul class="pagination">
      <li v-for="(link, index) in pagination.links" :key="index"
        :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
    </ul>
  </nav>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<invoice-modal ref="invoiceModal" @updated="loadAll"></invoice-modal>
<payment-modal ref="paymentModal" @updated="invoices"></payment-modal>

</template>
<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>